import SweetAlert from "sweetalert2";
export const deleteConfirmationModal = (id, handleFunc) => {
  SweetAlert.fire({
    title: "Estas seguro?",
    text: "Una vez eliminado el registro no podra recuperarse",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Ok",
    cancelButtonText: "Cancelar",
    reverseButtons: true,
  }).then((result) => {
    if (result.isConfirmed) {
      handleFunc(id);
    }
  });
};
